"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    resolver: function() {
        return resolver;
    }
});
var _core = require("@mantine/core");
var _Anchormodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/baseTheme/Anchor.module.css"));
var _Selectmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/baseTheme/Select.module.css"));
var _Inputmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/baseTheme/Input.module.css"));
var _TextInputmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/baseTheme/TextInput.module.css"));
var _Checkboxmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/baseTheme/Checkbox.module.css"));
var _DatePickerInputmodulecss = /*#__PURE__*/ _interop_require_default(require("../../dist/assets/baseTheme/DatePickerInput.module.css"));
var _colorsgenerator = require("@mantine/colors-generator");
var _lib = require("../lib");
var _colourconstantsbaas = /*#__PURE__*/ _interop_require_default(require("../colour-constants-baas"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var resolver = function(param) {
    var _param_other = param.other, headerNavBg = _param_other.headerNavBg, headerNavColor = _param_other.headerNavColor, mainColor = _param_other.mainColor, brandColor = _param_other.brandColor, splashColor = _param_other.splashColor;
    return {
        variables: _extends({
            "--header-nav-bg": headerNavBg,
            "--header-nav-color": headerNavColor,
            "--main-color": mainColor,
            "--brand-color": brandColor,
            "--splash-color": splashColor
        }, (0, _lib.prefixCSSVars)(_colourconstantsbaas.default)),
        dark: {},
        light: {}
    };
};
var BRAND_COLOR = "#827127";
var baseTheme = function(param) {
    var fontFamily = param.fontFamily, themeOverrides = param.themeOverrides;
    var brandPrimaryColor = (themeOverrides == null ? void 0 : themeOverrides.brandColor) || BRAND_COLOR;
    var _themeOverrides_brandColor;
    return {
        other: {
            headerNavBg: (themeOverrides == null ? void 0 : themeOverrides.headerNavBg) || "#fff",
            headerNavColor: (themeOverrides == null ? void 0 : themeOverrides.headerNavColor) || "#fff",
            mainColor: (themeOverrides == null ? void 0 : themeOverrides.mainColor) || "#FFF",
            brandColor: (themeOverrides == null ? void 0 : themeOverrides.brandColor) || "#D3DAE1",
            splashColor: (themeOverrides == null ? void 0 : themeOverrides.splashColor) || "#858B91",
            brandCollinsons: brandPrimaryColor
        },
        colors: {
            brandCollinsons: (0, _colorsgenerator.generateColors)((themeOverrides == null ? void 0 : themeOverrides.brandColor) || BRAND_COLOR)
        },
        primaryColor: "brandCollinsons",
        primaryShade: 9,
        defaultRadius: 4,
        fontFamily: fontFamily,
        fontFamilyMonospace: fontFamily,
        headings: {
            fontFamily: fontFamily
        },
        lineHeights: {
            xs: "1.4",
            sm: "1.45",
            md: "1.55",
            lg: "1.6",
            xl: "1.65"
        },
        fontSizes: {
            xs: (0, _core.rem)(12),
            sm: (0, _core.rem)(14),
            md: (0, _core.rem)(16),
            lg: (0, _core.rem)(18),
            xl: (0, _core.rem)(20),
            xxl: (0, _core.rem)(32)
        },
        components: {
            InputWrapper: _core.InputWrapper.extend({
                styles: function(param) {
                    var colors = param.colors;
                    return {
                        label: {
                            fontSize: "18px",
                            color: colors.dark[6]
                        },
                        required: {
                            color: colors.red[6]
                        },
                        error: {
                            color: colors.red[6]
                        }
                    };
                }
            }),
            Anchor: _core.Anchor.extend({
                classNames: function() {
                    return {
                        root: _Anchormodulecss.default.root
                    };
                }
            }),
            Modal: _core.Modal.extend({
                styles: function(param) {
                    var colors = param.colors;
                    return {
                        close: {
                            color: colors.dark[6]
                        },
                        header: {
                            minHeight: "auto"
                        },
                        content: {
                            minHeight: "auto"
                        }
                    };
                }
            }),
            Select: _core.Select.extend({
                classNames: function() {
                    return {
                        input: _Selectmodulecss.default.input
                    };
                }
            }),
            Input: _core.Input.extend({
                classNames: function() {
                    return {
                        input: _Inputmodulecss.default.input,
                        label: _Inputmodulecss.default.label,
                        invalid: _Inputmodulecss.default.invalid
                    };
                },
                vars: function() {
                    return {
                        wrapper: {
                            "--input-height": (0, _core.rem)(50),
                            "--input-fz": "1.2rem"
                        }
                    };
                }
            }),
            Button: _core.Button.extend({
                defaultProps: {
                    color: (_themeOverrides_brandColor = themeOverrides == null ? void 0 : themeOverrides.brandColor) != null ? _themeOverrides_brandColor : "#000"
                },
                vars: function() {
                    var _themeOverrides_brandColor;
                    return {
                        root: {
                            "--brand-color": (_themeOverrides_brandColor = themeOverrides == null ? void 0 : themeOverrides.brandColor) != null ? _themeOverrides_brandColor : "#000",
                            "--button-height": (0, _core.rem)(44)
                        }
                    };
                }
            }),
            TextInput: _core.TextInput.extend({
                classNames: function() {
                    return {
                        input: _TextInputmodulecss.default.input,
                        label: _TextInputmodulecss.default.label
                    };
                }
            }),
            NavLink: _core.NavLink.extend({
                styles: function() {
                    return {
                        label: {
                            color: brandPrimaryColor
                        }
                    };
                }
            }),
            Checkbox: _core.Checkbox.extend({
                classNames: function() {
                    return {
                        input: _Checkboxmodulecss.default.input
                    };
                }
            }),
            DatePickerInput: {
                classNames: function() {
                    return {
                        label: _DatePickerInputmodulecss.default.label,
                        input: _DatePickerInputmodulecss.default.input
                    };
                }
            }
        }
    };
};
var _default = baseTheme;
